import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
} from '@mui/material';

const ApproveRequestDialogManager = ({ isApprove, open, handleClose, handleApprove }) => {
  const [remark, setRemark] = useState('');
  const [errorRemark, setErrorRemark] = useState(false);

  useEffect(() => {
    setErrorRemark(false);
  }, [open])

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
    if (event.target.value.trim() !== '') {
      setErrorRemark(false);
    }
  };

  const handleSubmit = () => {
    if (!isApprove && remark.trim() === '') {
      setErrorRemark(true);
    } else {
      handleApprove(remark);
      handleClose(); // Close the dialog after submission
      setRemark(''); 
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{isApprove ? "Approve Request" : "Reject Request"}</DialogTitle>
      <DialogContent sx={{width: '30vw'}}>
        <DialogContentText>
          {
            `Please provide a remark for ${isApprove ? "approving" : "rejecting"} the request.`
          }
        </DialogContentText>

        <TextField
          autoFocus
          margin="dense"
          label={isApprove ? "Remark (optional)" : "Remark *"}
          type="text"
          fullWidth
          value={remark}
          onChange={handleRemarkChange}
          error={errorRemark}
          helperText={errorRemark ? "Remark is required." : ""}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          {isApprove ? "Approve" : "Reject"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveRequestDialogManager;
